import React, { useEffect, useState } from "react";
import { db, collection, onSnapshot } from "../boardData";
import { WidgetShell, EmptyState } from "./common";

const DONE = ["completed", "closed", "done"];

function toDate(v) {
  if (!v) return null;
  if (typeof v.toDate === "function") return v.toDate();
  if (typeof v.seconds === "number") return new Date(v.seconds * 1000);
  const d = new Date(v);
  return Number.isNaN(d.getTime()) ? null : d;
}

// Open / in-progress vehicle work orders from Workorders/Agencies/{agency}.
const WorkOrdersWidget = ({ config = {}, agency }) => {
  const [orders, setOrders] = useState([]);
  const limit = config.limit || 10;

  useEffect(() => {
    if (!agency) return undefined;
    const unsub = onSnapshot(
      collection(db, "Workorders", "Agencies", agency),
      (snap) => {
        const list = snap.docs
          .map((d) => ({ id: d.id, ...d.data() }))
          .filter((o) => !DONE.includes(String(o.status || "").toLowerCase()))
          .sort((a, b) => (toDate(a.dueDate) || 0) - (toDate(b.dueDate) || 0))
          .slice(0, limit);
        setOrders(list);
      },
      (err) => console.warn("work orders load failed", err)
    );
    return () => unsub();
  }, [agency, limit]);

  return (
    <WidgetShell title={`Work Orders${orders.length ? ` · ${orders.length}` : ""}`}>
      {orders.length === 0 ? (
        <EmptyState icon="🔧" label="No open work orders." />
      ) : (
        <div className="sb-wo-list">
          {orders.map((o) => {
            const due = toDate(o.dueDate);
            const pri = String(o.priority || "").toLowerCase();
            return (
              <div className="sb-wo" key={o.id}>
                <div className="sb-wo-main">
                  <span className="sb-wo-title">{o.title || o.description || "Work order"}</span>
                  {(o.unitNumber || o.vehicleId) && (
                    <span className="sb-wo-unit">{o.unitNumber || o.vehicleId}</span>
                  )}
                </div>
                <div className="sb-wo-meta">
                  {o.priority && <span className={`sb-wo-pri ${pri}`}>{o.priority}</span>}
                  <span className="sb-wo-status">{o.status || "Open"}</span>
                  {due && <span className="sb-wo-due">due {due.toLocaleDateString()}</span>}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </WidgetShell>
  );
};

export default WorkOrdersWidget;
